import { Controller } from 'stimulus';
import serializeFormToObject from '@/helpers/serializeFormToObject';
import hasHistorySupport from '@/helpers/hasHistorySupport';

class FilterController extends Controller {
  connect() {
    if (window.innerWidth < 768) {
      this.toggleFilters(false);
    }

    // We set this class to let CSS know we're done setting attributes.
    // For example the aria-expanded attribute will be set based on
    // the screen resolution. If we use the regular flow we would
    // see content jumping.
    this.element.classList.add('is-evaluated');
  }

  onChange() {
    const formData = serializeFormToObject(this.formTarget);

    this.fetchPage(formData)
      .then((res) => {
        this.outputProducts(res);
        this.outputUrl($(this.formTarget).serialize());
      });
  }

  fetchPage(formData) {
    return new Promise((resolve, reject) => {
      const formUrl = this.formTarget.getAttribute('action');

      $.ajax({
        url: formUrl,
        data: formData,
        success: resolve,
        error: reject,
      });
    });
  }

  outputProducts(res) {
    this.runOffMainThread(() => {
      const domParser = new DOMParser();
      const dom = domParser.parseFromString(res, 'text/html');

      // Retrieve products from the response...
      const productsList = dom.querySelector('[data-target="filter.products"]');
      const children = Array.prototype.slice.call(productsList.children);

      // Add height before deleting, to prevent...
      this.productsTarget.style.minHeight = `${this.productsTarget.offsetHeight}px`;

      // Remove current products...
      this.productsTarget.innerHTML = '';

      children.forEach((child) => {
        this.productsTarget.appendChild(child);
      });

      this.productsTarget.style.minHeight = 0;

      this.checkMoreButton();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  runOffMainThread(cb) {
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(() => {
        requestAnimationFrame(cb);
      });
      return;
    }

    setTimeout(cb);
  }

  // eslint-disable-next-line class-methods-use-this
  outputUrl(url) {
    if (!hasHistorySupport()) {
      return;
    }

    if (url.indexOf('http') === 0) {
      window.history.replaceState(null, null, url);
      return;
    }

    window.history.replaceState(null, null, `?${url}`);
  }

  showMore() {
    this.getHiddenProducts().slice(0, 6).forEach((productItem) => {
      productItem.removeAttribute('hidden');
    });

    this.checkMoreButton();
  }

  checkMoreButton() {
    if (!this.hasMoreProductsTriggerTarget) {
      return;
    }

    this.moreProductsTriggerTarget.style.display = this.getHiddenProducts().length
      ? 'block'
      : 'none';
  }

  getHiddenProducts() {
    return Array.prototype.slice.call(
      this.productsListTarget.querySelectorAll('[hidden]'),
    );
  }

  onCollapse(event) {
    const { target } = event;
    const isExpanded = target.getAttribute('aria-expanded') === 'true';

    this.toggleFilters(!isExpanded);
  }

  toggleFilters(state) {
    this.collapseButtonTarget.setAttribute('aria-expanded', state ? 'true' : 'false');
    this.formTarget.setAttribute('aria-expanded', state ? 'true' : 'false');
  }
}

FilterController.targets = [
  'form',
  'products',
  'productsList',
  'collapseButton',
  'moreProductsTrigger',
];

export default FilterController;
